import React from 'react';

export const SdmSpacer = ({
  style,
  paddingHorizontal,
  paddingVertical,
  flex,
  height,
  width = '100%',
  children,
}) => {
  const paddings = {
    paddingLeft: paddingHorizontal || style?.paddingLeft || 0,
    paddingRight: paddingHorizontal || style?.paddingRight || 0,
    paddingTop: paddingVertical || style?.paddingTop || 0,
    paddingBottom: paddingVertical || style?.paddingBottom || 0,
  };
  return (
    <div style={{ ...style, flex, height, width, ...paddings }}>{children}</div>
  );
};
